import {Heading} from '@primer/react'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './project-settings-card.module.css'

type ProjectSettingsCardProps = {
  showDivider?: boolean
  children: ReactNode
}

export function ProjectSettingsCard({children, showDivider}: ProjectSettingsCardProps) {
  return <div className={clsx(styles.ProjectSettingsCard, showDivider && styles.withDivider)}>{children}</div>
}

type ProjectSettingsCardHeaderProps = {
  title: string
  description: string
  children?: ReactNode
}

export function ProjectSettingsCardHeader({title, description, children}: ProjectSettingsCardHeaderProps) {
  return (
    <div className={styles.ProjectSettingsCardHeader}>
      <Heading as="h3" className={styles.cardTitle}>
        {title}
      </Heading>
      {children}
      <span className={styles.cardDescription}>{description}</span>
    </div>
  )
}

export function ProjectSettingsCardBody({children}: {children: ReactNode}) {
  return <div className={styles.ProjectSettingsCardBody}>{children}</div>
}
